import { useMemo, useCallback } from 'react';

import { Paper, Button } from '@material-ui/core';

import { FilterType } from 'generated';

import { useStyles } from './styles';

interface AreaWrapperProps {
  areas?: FilterType[];
  value?: FilterType;
  onChangeArea(area: FilterType): void;
}

export function AreaWrapper({
  areas,
  value,
  onChangeArea,
}: AreaWrapperProps): JSX.Element {
  const classes = useStyles();

  const memoAreas = useMemo(() => {
    return areas || [];
  }, [areas]);

  const getIsActive = useCallback(
    (area: FilterType) => {
      return area.id === value?.id;
    },
    [value],
  );

  const handleChangeArea = useCallback(
    (area: FilterType) => () => {
      onChangeArea(area);
    },
    [onChangeArea],
  );

  return (
    <Paper elevation={0} className={classes.root}>
      {memoAreas.map(area => (
        <Button
          variant="text"
          key={area.id}
          className={classes.navigationButton}
          color={getIsActive(area) ? 'primary' : undefined}
          onClick={handleChangeArea(area)}
        >
          {area.label}
        </Button>
      ))}
    </Paper>
  );
}
